// Shared helpers for rendering order status + money across order views.

import { formatCurrency } from "../common/utils";

export const STATUS_META = {
  pending: { label: "Pending", cls: "bg-warning text-dark" },
  paid: { label: "Paid", cls: "bg-info text-dark" },
  shipped: { label: "Shipped", cls: "bg-primary" },
  completed: { label: "Completed", cls: "bg-success" },
  cancelled: { label: "Cancelled", cls: "bg-secondary" },
};

export const ORDER_STATUSES = ["pending", "paid", "shipped", "completed", "cancelled"];

// Returns badge CSS class + fallback label. Prefer translating the label in the
// component via t(`orderStatus.${status}`); `label` is a non-i18n fallback.
export const statusBadge = (status) => {
  const meta = STATUS_META[status] || { label: status, cls: "bg-dark" };
  return meta;
};

// Formats a monetary value as currency. Delegates to the shared formatCurrency
// helper so every price across the app renders consistently.
export const money = (n) => formatCurrency(Number(n || 0));
